import { useMutation } from '@tanstack/react-query';

import {
  ExternalUserImportPayload,
  ExternalUserImportResponse,
  importExternalPromoUsers,
} from '~/services/PromoService';

export function useExternalPromoUserImport() {
  return useMutation<ExternalUserImportResponse, Error, ExternalUserImportPayload>({
    mutationFn: importExternalPromoUsers,
    retry: false,
  });
}
